export default __webpack_public_path__ + "static/media/AKBL.9e486986.png";